import { Types } from "./TrainingPlansContext";

const ModalReducer = (state: any, action: any) => {
  const { payload, type } = action;
  switch (type) {
    case Types.CREATE_TRAININGPLAN:
      return {
        ...state,
        createModalTrainingPlan: true,
      };
    case Types.DELETE_TRAININGPLAN:
      return {
        ...state,
        _id: payload._id,
        deleteModalTrainingModal: true,
      };

    case Types.UPDATE_TRAININGPLAN:
      return {
        ...state,
        _id: payload._id,
        updateModalTrainingPlan: true
      }
      
    case Types.CLEAR_TRAININGPLAN:
      return {
        ...state,
        _id: "",
        createModalTrainingPlan: payload.createModalTrainingPlan,
        deleteModalTrainingPlan: payload.deleteModalTrainingPlan,
      };
    case Types.CREATE_USER_TP:
      return {
        ...state,
        _id: payload._id,
        createModalUserTP: true,
      };
    case Types.CLEAR_USER_TP:
      return {
        ...state,
        _id: payload._id,
        createModalUserTP: false,
      };
    default:
      return state;
  }
};
export default ModalReducer;
